import { TranslatePipe } from '../../filters/translate.pipe';
import { ElementRef } from '@angular/core';
import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import Config from '../../utils/config.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import $ from 'jquery';
import moment from 'moment';
import 'daterangepicker';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
	standalone: true,
	selector: 'input-datepicker',
	templateUrl: './input-datepicker.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class InputDatepickerComponent implements OnInit, OnDestroy {
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	
	@Input() isRequired: any | undefined;
	@Input() minDate: any | undefined;
	@Input() hasDropdowns: any | undefined;
	@Input() isSmall: any | undefined;
	@Input() hasTimepicker: any | undefined;
	@Input() name: any | undefined;
	@Input() hasCalendarIcon: any | undefined;
	@Input() isSingleDate: any | undefined;
	@Input() opens: any | undefined;
	@Input() model: any;
	@Output() modelChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() parentEl: any | undefined;
	@Input() isAutoApplying: any | undefined;
	@Input() id: any | undefined;
	@Input() placeholder: any | undefined;
	@Input() startDate: any | undefined;
	@Input() isClearable: any | undefined;
	
	vm: any = undefined;
	watcher: any = undefined;
	
	constructor(private elementRef: ElementRef) {
		this.vm = this;
	}
	
	ngOnInit() {
		this.handleDatepickerInit();
		this.vm.handleInputReset = this.handleInputReset;
	}
	
	ngOnDestroy() {
		if (this.vm.datepicker) this.vm.datepicker.remove();
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}
	
	handleDatepickerInit() {
		var user: any = this.session.getSession().user;
		var language: any = (user.deviceLanguage || this.config.getSettings().DEFAULT_LANG).slice(0, 2);
		
		this.vm.datepickerInputElement = this.angularHelperService.element(this.elementRef.nativeElement)[0].querySelector('input');
		if (!this.vm.datepickerInputElement) return;
		this.vm.datepickerFormat = this.vm.hasTimepicker ? 'DD.MM.YYYY H:mm' : 'DD.MM.YYYY';
		
		this.handleInputReset();
		this.resetDateRangePicker(language);
		this.vm.datepicker.container.addClass('c-datepicker');
		
		var currentModel = this.vm.model;
		this.watcher = this.angularHelperService.createInterval(() => {
			var newModel = this.vm.model;
			if (!this.angularHelperService.isEqual(currentModel, newModel)) {
				if (newModel && newModel.start) {
					currentModel = Object.assign({}, newModel);
				} else {
					currentModel = newModel;
				}
			}
		}, 300);
	}
	
	handleInputReset() {
		this.vm.model = this.vm.isSingleDate ? undefined : {};
		this.vm.inputModel = this.vm.startDate ? moment(this.vm.startDate).format(this.vm.datepickerFormat) : undefined;
	}
	
	resetDateRangePicker(language) {
		var pickerEl: any = $(this.vm.datepickerInputElement);
		var momentRef: any = moment.localeData(language);
		this.vm.datepicker = pickerEl.daterangepicker({
			applyButtonClasses: 'c-button--s1 u-osl-xs',
			autoApply: this.vm.isAutoApplying,
			autoUpdateInput: this.vm.isAutoApplying,
			buttonClasses: 'c-button c-button--narrow',
			cancelButtonClasses: 'c-button--s6',
			linkedCalendars: false,
			locale: {
				firstDay: 1,
				daysOfWeek: momentRef._weekdaysShort,
				monthNames: momentRef._monthsShort,
				format: this.vm.datepickerFormat,
				applyLabel: this.angularFilterHelperService.translate('Modal.Button.Select'),
				cancelLabel: this.angularFilterHelperService.translate('Common.Cancel'),
			},
			minDate: this.vm.minDate ? moment(this.vm.minDate) : moment(),
			opens: this.vm.opens || 'left',
			parentEl: this.vm.parentEl || 'body',
			singleDatePicker: this.vm.isSingleDate,
			showDropdowns: this.vm.hasDropdowns,
			startDate: this.vm.startDate ? moment(this.vm.startDate) : moment(),
			timePicker: this.vm.hasTimepicker,
			timePicker24Hour: true,
			timePickerSeconds: false,
		}, (start, end) => {
			if (!new Date(start) || (!this.vm.isSingleDate && !new Date(end))) return;
			
//			this.angularStateHelperService.scopeApply(this, () => {
			if (this.vm.isSingleDate) {
				this.vm.model = start;
			} else {
				this.vm.model = {
					start: start,
					end: end
				};
			}
			this.modelChange.emit(this.vm.model);
//			});
		}).data('daterangepicker');
	}
	
}